import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex: 1;
  padding: 5px;

  .container-segment {
    flex: 1;
  }

  .button-center-icons {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
`
